import { Component, Input, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Logger, LoggerFactory } from '../../core/logger.service';
import { FlyoutOpeningData, PersonDetails, VisitEvent } from '../flyout-models';
import { Subscription } from 'rxjs';
import { FlyoutService } from '../flyout.service';

@Component({
  selector: 'app-flyout-utm-campaigns',
  templateUrl: './flyout-utm-campaigns.component.html',
  styleUrls: ['./flyout-utm-campaigns.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FlyoutUtmCampaignsComponent implements OnInit, OnDestroy {
  private readonly logger: Logger;
  private _openingData: FlyoutOpeningData;
  public personDetails: PersonDetails;
  private personSubscription: Subscription;
  private subscriptionArray: Subscription[] = [];
  public campaignsStatistics = [] as Array<{
    campaignName: string;
    count: number;
  }>;
  public sortingProperty = 'name';
  public sortingDirection = -1;

  @Input() public set flyoutOpeningData(openingData: FlyoutOpeningData) {
    this._openingData = openingData;
  }

  public get flyoutOpeningData(): FlyoutOpeningData {
    return this._openingData;
  }

  constructor(
    public readonly loggerFactory: LoggerFactory,
    private readonly flyoutService: FlyoutService,
  ) {
    this.logger = loggerFactory.get('FlyoutUtmCampaignsComponent');
  }

  ngOnInit() {
    this.personSubscription = this.flyoutService.personDetailsBS.subscribe((personDetails: PersonDetails) => {
      this.personDetails = personDetails;
      this.processCampaignStatistics();
    });
  }

  private processCampaignStatistics() {
    if (!this.personDetails) {
      return;
    }
    this.campaignsStatistics = [];
    if (this.personDetails.campaignEvents) {
      const campaignsMap = {} as { string: number };
      this.personDetails.campaignEvents.forEach((utmCampaign: VisitEvent) => {
        if (campaignsMap[utmCampaign.name.toLowerCase()]) {
          campaignsMap[utmCampaign.name.toLowerCase()] = campaignsMap[utmCampaign.name.toLowerCase()] + 1;
        } else {
          campaignsMap[utmCampaign.name.toLowerCase()] = 1;
        }
      });
      this.campaignsStatistics = Object.keys(campaignsMap).map((campaignName) => {
        return {
          campaignName: campaignName,
          count: campaignsMap[campaignName],
        };
      });
      this.sortingDirection = -1;
      this.sortByProperty('count');
    }
  }

  public sortByProperty(property: string) {
    if (property === this.sortingProperty) {
      this.sortingDirection = -1 * this.sortingDirection;
    }
    this.sortingProperty = property;
    this.campaignsStatistics.sort((a, b) => {
      return a[property] > b[property] ? this.sortingDirection * 1 : this.sortingDirection * -1;
    });
  }

  ngOnDestroy(): void {
    this.subscriptionArray.push(this.personSubscription);
    this.subscriptionArray.forEach((subs) => subs && subs.unsubscribe());
  }
}
